import angular from 'angular';

angular.module('cloudX').directive('cxLegalFormSelect', function() {
  return {
    restrict: 'E',
    template:
      '<a href="" editable-legal-form="value" onbeforesave="beforeSave({newValue:$data})" onaftersave="afterSave({newValue:$data})" blur="submit" edit-disabled="disabled"> <span ng-show="value || value===0" >{{value | translateList:\'legalForm\'}}</span> ' +
      '<i class="glyphicon glyphicon-pencil" ng-show="!value && value!==0"></i> </a>',
    scope: {
      value: '=data',
      beforeSave: '&',
      afterSave: '&',
      disabled: '=?',
    },
  };
});
